import React from 'react';

import {LocalizedLink} from 'components/ReactRouterDomLocalized';

import paths from 'paths';
import {getLocale} from 'l10n';

export default function FilmAmateurTag({tag}) {
    let locale = getLocale();
    let name = 'name',
        slug = 'slug';

    if (locale !== 'fr') {
        name = 'name_en';
        slug = 'slug_en';
    }

    return (
        <LocalizedLink to={paths.amateurFilms.toPath({slug: tag[slug]})}>
            {tag[name]}
        </LocalizedLink>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialPage/tag.js